import { Analysis, PossibleRootCauseCategory } from '.';

export class LipidsAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.cholesterol.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16000);
        } else if (this.ba.cholesterol.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16010);
        }

        if (this.ba.hdl.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16020);
        } else if (this.ba.hdl.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16030);
        }

        if (this.ba.triglycerides.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16040);
        } else if (this.ba.triglycerides.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16050);
        }

        if (this.ba.ldl.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16060);
        } else if (this.ba.ldl.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16070);
        }

        if (this.ba.cholesterolHDLRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16080);
        }

        if (this.ba.triglyceridesHDLRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16090);
        }
        if (this.ba.apolipoproteinA1.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16091);
        } else if (this.ba.apolipoproteinA1.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16092);
        }
        if (this.ba.apolipoproteinB.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16094);
        } else if (this.ba.apolipoproteinB.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16095);
        }
        if (this.ba.apoBapoA1Ratio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16097);
        }
        if (this.ba.lipoproteinA.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16100);
        } else if (this.ba.lipoproteinA.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_16110);
        }
    }
}